// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { containerStyles } from "@rpsc/Overrides/Widgets/OnePageCheckout/OnePageCheckoutPageContainer";
import { constants, DivWrapper } from "@rpsc/XDL/constants";
import IconArrowLeftLink from "@rpsc/XDL/Icons/IconArrowLeftLink";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, createLinkIconStyles, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

containerStyles.backToCartLink = {
    ...createLinkIconStyles(
        IconArrowLeftLink,
        {
            css: css`
                margin-top: 12px;
                margin-bottom: 20px;
            `,
        },
        {
            size: 12,
            lineHeight: "13px",
            weight: fontConfig.weight.bold,
        },
        {
            src: IconArrowLeftLink,
            size: 13,
            css: css`
                &,
                & > svg {
                    width: 11px;
                }
            `,
        },
    ),
};

containerStyles.addressesContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 24px;
    `,
};

containerStyles.title = {
    variant: "h1",
    css: css`
        &&& {
            padding-bottom: 8px;
            margin-bottom: 16px;
            border-bottom: 1px solid ${color("common.border")};
        }
    `,
};

containerStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, auto) minmax(0, 378px);
        gap: 22px;
        ${xScreen("lte", "lg")} {
            grid-template-columns: minmax(0, auto) minmax(0, 319px);
        }
        ${xScreen("lte", "md")} {
            grid-template-columns: minmax(0, auto) 50%;
            gap: 20px;
        }
        ${xScreen("lte", "sm")} {
            display: flex;
            flex-direction: column;
            gap: 24px;
        }
    `,
};
containerStyles.paymentContainer = containerStyles.shippingContainer = {
    css: css`
        & > ${DivWrapper}:not(:empty) {
            border-top: 1px solid ${color("common.border")};
            padding-top: 24px;
        }
    `,
};
containerStyles.leftItemsSection = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 24px;
    `,
};
